import { FunctionComponent, useState, useEffect } from "react";
import React = require("react");
import { Button, Table } from "react-bootstrap";
import useHotkeys from "@reecelucas/react-use-hotkeys";
import { CM, IZComandoFormaState } from "../../zcommon/contracts";
import { Services } from "../services";

type ZButtonComandoProps = {
    zComando: IZComandoFormaState;
    despacharComandoLineaEstado: (comando: IZComandoFormaState) => void;
    esRegionActiva?: boolean;
    esLineaEstadoButton?: boolean
}

export const ZButtonComando: FunctionComponent<ZButtonComandoProps> = ({
    zComando,
    despacharComandoLineaEstado,
    esRegionActiva,
    esLineaEstadoButton,
}) => {

    let zPantexServices = new Services.ZRecursoServices();
    let zComandoInfo = zPantexServices.getCMIcon(zComando);

    // useEffect(() => {
    //     const handleKeyPress = (event: KeyboardEvent) => {

    //         if (event.key === 'Enter' && zComando.desh != 1 && zComandoInfo.hotKey) {
    //             event.preventDefault();  // evita que enviemos el formulario por defecto

    //             const form = (event.target as HTMLElement).closest('form'); // busca el formulario más cercano
    //             // console.log("1st", form);
    //             if (form) {
    //                 const inputs = Array.from(form.elements) as HTMLInputElement[];  // obtiene los elementos del formulario --> Debemos crear los alias para que entienda que es un HTMLInputElement
    //                 const index = zComando.id//inputs.indexOf(event.target as HTMLInputElement); // obtiene el índice del elemento actual

    //                 const nextIndex = (index-1) % inputs.length; // calcula el índice del siguiente elemento
    //                 const nextInput = inputs[nextIndex]; // obtiene el siguiente elemento

    //                 nextInput.focus(); // pone el foco en el siguiente elemento
    //                 //nextInput.setSelectionRange(0, 0); // Mueve el cursor al principio 
    //                 console.log('----zcomando.id---------',index )

    //             } else {
    //                 const cell = (event.target as HTMLElement).closest('td');
    //                 if (cell) {
    //                     const row = cell.closest('tr'); // buscamos la fila mas cercana
    //                     if (row) {
    //                         const cells = Array.from(row.cells) as HTMLElement[]; // obtenemos las celdas de la fila
    //                         const cellIndex = cells.indexOf(cell); // obtenemos los indices de las celdas
                            
    //                         const nextIndexCell = (cellIndex + 1) % cells.length;
    //                         const nextCell = cells[nextIndexCell]; // siguiente celda
    //                         const nextInput = nextCell.querySelector('input, select, textarea') as HTMLElement; // buscamos el siguiente elemento de entrada
    //                         if (nextInput) {
    //                             nextInput.focus();
    //                             // if (nextInput instanceof HTMLInputElement || nextInput instanceof HTMLTextAreaElement) {
    //                             //     nextInput.setSelectionRange(0, 0); // pone el foco en el siguiente elemento y establece el rango de selección
    //                             // }
    //                         }
    //                     }
    //                 }
    //             }
    //         }
    //     };
        
        
    
    //     document.addEventListener('keydown', handleKeyPress);

    //     return () => {
    //         document.removeEventListener('keydown', handleKeyPress); // elimina el evento al desmontar el componente --> Cleanup es una función que se ejecuta cuando el componente se desmonta ... es decir cuando se elimina del DOM o se cambia de página o se cambia el estado del componente
    //     };
    // }, [zComando, despacharComandoLineaEstado, zComandoInfo]); // se ejecuta cada vez que cambia el valor de zComando, despacharComandoLineaEstado específicamente cuando se monta el componente o cuando se actualiza el valor de zComando

    useHotkeys(zComandoInfo.hotKey ?? '', (event: any) => {
        if (zComando.desh !== 1 && zComandoInfo.hotKey) {
            event.preventDefault(); // evita que se ejecute la acción por defecto del navegador
            despacharComandoLineaEstado(zComando); // Si zComando.desh es igual a 1, las acciones no se ejecutarán, lo que probablemente signifique que el comando está deshabilitado. Si zComando.desh no es igual a 1, entonces el comando está habilitado y las acciones se permiten.
        }
    });

    return (
        <Button
            bsStyle={esRegionActiva && esLineaEstadoButton ? "primary" : "default"}
            title={`${zComando.etq} - ${zComandoInfo?.hotKeyTitle}`}
            disabled={zComando.desh === 1}
            onClick={() => despacharComandoLineaEstado(zComando)}
        >
            {(!zComandoInfo.icono) && zComando.etq}
            <span className={zComandoInfo.icono} aria-hidden="true" />
        </Button>
    );
};


// WEBPACK FOOTER //
// ./src/modules/zpantex/components/ZButtonComando.tsx